// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.register-card {
  width: 100%;
  padding-top: 60px;
  padding-bottom: 30px;
}
.register-card__background {
  background: #f5f5f5;
}
.register-card__card-profile-changes {
  margin: auto;
  background-color: #ffffff;
  box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.06);
  border-radius: 8px;
}
.register-card__head {
  background: #f5f5f5;
}
.register-card__head__head-text {
  padding-top: 10px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 28px;
}
.register-card__head__subhead-text {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #868686;
  padding-top: 10px;
}
.register-card__body {
  padding-top: 30px;
}
.register-card__body__table {
  width: 100%;
}
.register-card__body__left {
  width: 65%;
  border-right: 1px solid #e9e9e9;
}
.register-card__body__right {
  width: 35%;
  padding: 3%;
}

.basic-info {
  padding: 5%;
}
.basic-info__head {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  color: #353d47;
}
.basic-info__form {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  color: #353d47;
}
.basic-info__text-inputs {
  margin-top: 30px;
}
.basic-info__date {
  display: flex;
  width: 100%;
  margin-top: 30px;
}
.basic-info__date__calendar-input {
  margin-right: 20px;
  width: 400px;
}
.basic-info__date__dual-input {
  width: 100%;
}

.info__part2 {
  margin-top: 100px;
}
.info__head {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #666666;
}
.info__body {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #999999;
}`, "",{"version":3,"sources":["webpack://./src/components/employee-registration/register-card/register-card.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,iBAAA;EACA,oBAAA;AACJ;AACI;EACI,mBAAA;AACR;AAEI;EACI,YAAA;EACA,yBAAA;EACA,4CAAA;EACA,kBAAA;AAAR;AAGI;EACI,mBAAA;AADR;AAGQ;EACI,iBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AADZ;AAIQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;AAFZ;AAMI;EACI,iBAAA;AAJR;AAMQ;EACI,WAAA;AAJZ;AAOQ;EACI,UAAA;EACA,+BAAA;AALZ;AAQQ;EACI,UAAA;EACA,WAAA;AANZ;;AAWA;EACI,WAAA;AARJ;AAUI;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AARR;AAWI;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AATR;AAYI;EACI,gBAAA;AAVR;AAaI;EACI,aAAA;EACA,WAAA;EACA,gBAAA;AAXR;AAaQ;EACI,kBAAA;EACA,YAAA;AAXZ;AAcQ;EACI,WAAA;AAZZ;;AAkBI;EACI,iBAAA;AAfR;AAkBI;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAhBR;AAmBI;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAjBR","sourcesContent":[".register-card {\n    width: 100%;\n    padding-top: 60px;\n    padding-bottom: 30px;\n\n    &__background {\n        background: #f5f5f5;\n    }\n\n    &__card-profile-changes {\n        margin: auto;\n        background-color: #ffffff;\n        box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.06);\n        border-radius: 8px;\n    }\n\n    &__head {\n        background: #f5f5f5;\n\n        &__head-text {\n            padding-top: 10px;\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 700;\n            font-size: 28px;\n        }\n\n        &__subhead-text {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 400;\n            font-size: 14px;\n            line-height: 20px;\n            color: #868686;\n            padding-top: 10px;\n        }\n    }\n\n    &__body {\n        padding-top: 30px;\n\n        &__table {\n            width: 100%;\n        }\n\n        &__left {\n            width: 65%;\n            border-right: 1px solid #e9e9e9;\n        }\n\n        &__right {\n            width: 35%;\n            padding: 3%;\n        }\n    }\n}\n\n.basic-info {\n    padding: 5%;\n\n    &__head {\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 700;\n        font-size: 20px;\n        line-height: 30px;\n        color: #353d47;\n    }\n\n    &__form {\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 700;\n        font-size: 20px;\n        line-height: 30px;\n        color: #353d47;\n    }\n\n    &__text-inputs {\n        margin-top: 30px;\n    }\n\n    &__date {\n        display: flex;\n        width: 100%;\n        margin-top: 30px;\n\n        &__calendar-input {\n            margin-right: 20px;\n            width: 400px;\n        }\n\n        &__dual-input {\n            width: 100%;\n        }\n    }\n}\n\n.info {\n    &__part2 {\n        margin-top: 100px;\n    }\n\n    &__head {\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 700;\n        font-size: 14px;\n        line-height: 20px;\n        color: #666666;\n    }\n\n    &__body {\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 12px;\n        line-height: 18px;\n        color: #999999;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
